import { Paper, Typography, Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { tbColors } from 'styles/colors/tbColors';

interface Props {
  titleId: string;
  textId: string;
  imagePath: string;
  icon: 'expansion' | 'growth' | 'trends';
}

const iconMap = {
  expansion: '/icons/expansion.png',
  growth: '/icons/growth.png',
  trends: '/icons/trend.png',
};

function BenchmarkingFeatureCard({ titleId, textId, imagePath, icon }: Props) {
  const highlight = (chunks: React.ReactNode) => <span style={{ color: tbColors.all.turquoise[500] }}>{chunks}</span>;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        borderRadius: '16px',
        backgroundColor: tbColors.all.snow[100],
        display: 'flex',
        flexDirection: 'column',
        border: 'none',
        height: '100%',
        width: 'full',
      }}
      className="col-span-6 xl:col-span-4"
    >
      <Box sx={{ mb: 2, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ mb: 3 }}>
          <img src={iconMap[icon]} alt={icon} style={{ width: 52, height: 52 }} />
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'Figtree',
            fontWeight: 800,
            color: tbColors.all.ash[900],
            fontSize: '20px',
            lineHeight: '1.2',
            mb: 2,
          }}
        >
          <FormattedMessage id={titleId} values={{ highlight }} />
        </Typography>
        <Box sx={{ mb: 3 }}>
          <img
            src={imagePath}
            alt="Performance Chart"
            style={{
              width: '100%',
              borderRadius: '8px',
              objectFit: 'contain',
              minHeight: 275,
              maxHeight: 275,
              objectPosition: 'left',
            }}
          />
        </Box>

        <Typography
          variant="body2"
          sx={{
            fontFamily: 'Figtree',
            fontSize: '14px',
            lineHeight: '1.6',
            fontWeight: 300,
          }}
        >
          <FormattedMessage id={textId} />
        </Typography>
      </Box>
    </Paper>
  );
}

export { BenchmarkingFeatureCard };
